import { combineReducers } from '@reduxjs/toolkit';

import { reducer as auth } from './auth';
import { reducer as toast } from './toast';
import { reducer as main } from './main';
import { reducer as profile } from './profile';
import { reducer as posts } from './posts';
import { reducer as attach } from './attach';
import { reducer as feed } from './feed';
import { reducer as search } from './search';
import { reducer as followers } from './followers';
import { reducer as groups } from './groups';
import { reducer as im } from './im';
import { reducer as realtime } from './realtime';
import { reducer as blacklist } from './blacklist';
import { reducer as notify } from './notify';
import { reducer as invite } from './invite';
import { reducer as editGroup } from './editGroup';
import { reducer as resolver } from './resolver';
import { reducer as likes } from './likes';
import { reducer as balance } from './balance';
import { reducer as agent } from './agent';
import { reducer as monetization } from './monetization';
import { reducer as explore } from './explore';
import { reducer as subscriptions } from './subscriptions';
import { reducer as statistics } from './statistics';
import { reducer as paid } from './paid';
import { reducer as pay } from './pay';
import { reducer as cloud } from './cloud';
import { reducer as stories } from './stories';
import { reducer as streams } from './streams';
import { reducer as ads } from './ads';
import { reducer as balancePay } from './balancePay';
import { reducer as lists } from './lists';
import { reducer as battle } from './battle';
import { reducer as confirm } from './confirm';
import { reducer as app } from './app';
import { reducer as roulette } from './roulette';
import { reducer as promoCode } from './promoCode';
import { reducer as live } from './live';
import { reducer as reels } from './reels';
import { reducer as pushes } from './pushes';
import { reducer as bundles } from './bundles';
import { reducer as dashboard } from './dashboard';
import { reducer as paymentMethods } from './paymentMethods';
import { reducer as trialLinks } from './trialLinks';
import { reducer as promoLinks } from './promoLinks';
import { reducer as notes } from './notes';
import { reducer as telegram } from './telegram';
import { reducer as offers } from './offers';
import { reducer as mine } from './mine';
import { reducer as addListMember } from './addListMember';
import { reducer as gifts } from './gifts';
import { reducer as leaderboard } from './leaderboard';
import { reducer as adventCalendar } from './adventCalendar';
import { reducer as passkey } from './passkey';
import { reducer as aiCaps } from './aiCaps';

export const rootReducer = combineReducers({
  auth,
  toast,
  main,
  profile,
  posts,
  attach,
  feed,
  search,
  followers,
  groups,
  im,
  realtime,
  blacklist,
  notify,
  invite,
  editGroup,
  resolver,
  likes,
  balance,
  agent,
  monetization,
  explore,
  subscriptions,
  statistics,
  paid,
  pay,
  cloud,
  stories,
  streams,
  ads,
  balancePay,
  lists,
  battle,
  confirm,
  app,
  roulette,
  promoCode,
  live,
  reels,
  pushes,
  bundles,
  paymentMethods,
  dashboard,
  trialLinks,
  promoLinks,
  notes,
  telegram,
  offers,
  mine,
  addListMember,
  gifts,
  leaderboard,
  adventCalendar,
  passkey,
  aiCaps,
});

export type RootState = ReturnType<typeof rootReducer>;
